import Api from './Api'
import Vue from 'vue'
import router from '../router/index'
import store from "../store/store"
const ToastTabError     = { theme: 'toasted-primary', icon: 'warning', position: 'top-center', duration: 8000, fitToScreen: true, type: 'error' }
const codePartenaire    = store.state.code_partenaire

export default async function kpay_payment(amount, numDevis, customer_phone) {
    const data = {
        customerPhoneNumber: "221" + customer_phone.substring(customer_phone.length - 9),
        amount: 100,//amount
        description: "Paiement du devis No : " + numDevis,
        correlationReference: codePartenaire + "_" + numDevis.replace(/[/]/g, '_')
    }
    try {
        const initpay = await Api().post("kpay/init/payment", data)
        return initpay.data
    } catch (err) {
            Vue.toasted.show(error_reader(err.response.data.error), ToastTabError)
    }
}

function BuildAmount(amount) {
    if (store.state.user.email == "mowencleopas@assuraf.com") {
        return 10
    } else {
        return amount
    }
}

function error_reader(msg)
{
    const error_array=[
        {fr:"Le système de paiement n'est pas disponible pour le moment", eng:"kpay system is not available"},
        {fr:"Erreur Serveur",eng:"Server error"},
        {fr:"Le numéro renseigné n'a pas de compte kpay !", eng:"Receiver is not registered"},
        {
            fr:"Vous n'avez pas assez de fonds pour ce paiement. Veuillez effectuer un depot par carte bancaire ou auprès de l'agent Kpay le plus proche", 
            eng:"insufficient fund"
        }
    ]

    let checker = "Erreur Serveur !"
    for(let v of error_array){
        if(msg==v.eng){
            checker = v.fr
        }
    }
    return checker
}